import React, { useState } from "react";
import "./CompanyCard.css";
import img from "../images/img_1.jpg";
import { Link } from "react-router-dom";
import axios from "../axios/axios";

function CompanyCard({
  jobType,
  position,
  minSalary,
  maxSalary,
  location,
  logo,
  ownerid,
  getJobs,
}) {
  const [editable, setEditable] = useState(false);

  const toggleEdit = () => {
    setEditable(!editable);
  };

  const handledeletejob = async () => {
    try {
      await axios.delete(`http://localhost:3001/api/jobs/${ownerid}`);
      getJobs();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="cardc">
        <img src={logo ? logo : img} />
        <div className="cardContentc">
          <div className="cardDescription">
            <div className="JobDescription">
              <ul>
                <li>
                  <span>Position: </span>
                  <p
                    style={{ border: editable ? "2px solid black" : "none" }}
                    contentEditable={editable}
                  >
                    {position}
                  </p>
                </li>
                <li>
                  <span>Location: </span>
                  <p
                    style={{ border: editable ? "2px solid black" : "none" }}
                    contentEditable={editable}
                  >
                    {location}
                  </p>
                </li>
              </ul>
            </div>
            <div className="JobDescription">
              <ul>
                <li>
                  <span>JobType: </span>
                  <p
                    style={{ border: editable ? "2px solid black" : "none" }}
                    contentEditable={editable}
                  >
                    {jobType}
                  </p>
                </li>
                <li>
                  <span>Salary: </span>
                  <p
                    style={{ border: editable ? "2px solid black" : "none" }}
                    contentEditable={editable}
                  >
                    {minSalary}-{maxSalary}$
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Link
          style={{ textDecoration: "none", color: "inherit" }}
          to={`/company/appliedUsers/${ownerid}`}
        >
          <button className="userBtn">Applied Users</button>
        </Link>
        <div className="jobController">
          <button onClick={toggleEdit}>{editable ? "Save " : "Edit"}</button>

          <button onClick={handledeletejob}>Delete</button>
        </div>
      </div>
    </>
  );
}

export default CompanyCard;
